import { PunchoutParams } from '@/hooks/use-send-challenge-answer';
import { useMemo } from 'react';

// Reads the LIVE URL after boot. If this flow gains/renames a query param,
// add it to RESERVED_BOOT_QUERY_KEYS (domain/microproducts/boot-params.web)
// so storefront URL writes stay suppressed while it's in play.
export const usePunchoutParams = (): PunchoutParams | null => {
  return useMemo(() => {
    const { punchOutCookie, userID } = Object.fromEntries(
      new URLSearchParams(window.location.search),
    );

    return punchOutCookie && userID
      ? { cookie: punchOutCookie, username: userID }
      : null;
  }, []);
};
